import { cn } from '@lib/cn'
import { HTMLAttributes, forwardRef } from 'react'

type As = 'div' | 'p' | 'span' | 'label' | 'li'
// These are coming straight from the Rolex docs, don't blame me
type Variant =
  | 'body24'
  | 'body20'
  | 'legend16'
  | 'legend14'
  | 'fixed22'
  | 'fixed16'
  | 'fixed14'
  | 'quote'

export type TextProps = HTMLAttributes<HTMLElement> & {
  variant?: Variant
  as?: As
  weight?: 'bold' | 'light'
}

export const Text = forwardRef<HTMLElement, TextProps>(
  (
    {
      variant = 'body20',
      weight = 'bold',
      children,
      className = '',
      as: Component = 'div',
      ...rest
    },
    ref,
  ) => {
    return (
      <Component
        ref={ref as any}
        className={cn(
          'tw-text-with-links font-rolex text-current',
          weight === 'bold' ? 'font-bold' : 'font-light',
          variant === 'body24' &&
            'text-[18px] leading-[1.2] lg:text-[20px] xl:text-[22px] huge:text-[24px]',
          variant === 'body20' && 'text-[18px] leading-[1.6] lg:text-[19px] huge:text-[20px]',
          variant === 'legend16' &&
            'text-[12px] leading-[1.1] lg:text-[13px] xl:text-[15px] huge:text-[16px]',
          variant === 'legend14' &&
            'text-[10px] leading-[1.1] lg:text-[11px] xl:text-[13px] huge:text-[14px]',
          variant === 'fixed22' && 'text-[22px] leading-[1.6]',
          variant === 'fixed16' && 'text-[16px] leading-[1.1]',
          variant === 'fixed14' && 'text-[14px] leading-[1.1]',
          variant === 'quote' &&
            'font-rolexQuote text-[30px] !font-normal leading-[1.3] lg:text-[32px] xl:text-[40px] huge:text-[50px]',
          className,
        )}
        {...rest}
      >
        {children}
      </Component>
    )
  },
)

Text.displayName = 'Text'
